import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronRight} from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";
import React, {ReactNode} from "react";

interface BreadcrumbProps {
    title: string;
    url?: string;
    subTitle?: string;
    children?: ReactNode;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({title, url = '/', subTitle, children}) => {
    return (
        <>
            <section id='top-2' className="section-box breadcrumb-head position-relative">
                <div className="banner-hero bg-light-green">
                    <div className="container">
                        <div className="row animate__animated animate__fadeIn">
                            <div className="col-12">
                                <h1 className="text-display-3">{title ?? "Loading..."}</h1>
                            </div>
                            {children}
                            <div className="col-12 mt-10 pb-lg-5">
                                <Link href="/" legacyBehavior>
                                    <a className="btn btn-link p-0">Home</a>
                                </Link>
                                <FontAwesomeIcon className='font-xs mx-2' icon={faChevronRight}/>
                                <Link href={url} legacyBehavior>
                                    <a className="btn btn-link p-0">{subTitle ?? title}</a>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Breadcrumb;
